// This file is part of Indico.UN.
// Copyright (C) 2019 - 2026 United Nations. All rights reserved.

import React, {useState} from 'react';
import {FormSpy} from "react-final-form";
import {Message, Icon, List} from 'semantic-ui-react';

import {Translate} from '../../../client/i18n';


export default function SignupPasswordChecklist() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleFormChange = ({values: {password, password_confirm}}) => {
    setPassword(password !== undefined ? password : '');
    setConfirmPassword(password_confirm !== undefined ? password_confirm : '');
  }

  // The checks defined here should always be the same as the checks in
  // `_validate_additional_password_checks` defined at un/util/passwords.py.
  const minLength = password.length >= 12;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasUpperAndLowerCase = hasUpperCase && hasLowerCase;
  const hasNumber = /[0-9]/.test(password);
  const noWhitespace = !/\s/.test(password);
  const noIndico = !(/[i1|]nd[1i|]c[o0]/i.test(password));
  const passwordsMatch = password === confirmPassword;

  const checkList = [
    {id: 1, message: Translate.string('Be at least 12 characters long'), valid: minLength},
    {id: 2, message: Translate.string('Contain uppercase and lowercase characters'), valid: hasUpperAndLowerCase},
    {id: 3, message: Translate.string('Contain numbers'), valid: hasNumber},
    {id: 4, message: Translate.string('Not contain whitespace'), valid: noWhitespace},
    {id: 5, message: Translate.string('Not contain the word "indico" or variations'), valid: noIndico},
    {id: 6, message: Translate.string('Match confirm password '), valid: passwordsMatch},
  ]

  return (
    <>
      <FormSpy
        subscription={{values: true}}
        onChange={handleFormChange}
      />
      <Message>
        <Message.Header><Translate>The password must:</Translate></Message.Header>
        <List>
          {checkList.map(checkListItem => (
            <List.Item key={checkListItem.id}>
              <Icon name={checkListItem.valid ? 'check' : 'times'} color={checkListItem.valid ? 'green' : 'red'} />
              {checkListItem.message}
            </List.Item>
          ))}
        </List>
      </Message>
    </>
  );
};
